/**
 * Use this component whenever you would need <a> or <Link>.
 * Use with `href` property to create an <a> tag and with `to` property
 * to create a <Link> tag.
 *
 * With using this component for all link elements we make sure links have
 * the proper hover and focus styles. Atlaskit/button with link appearance
 * does not have a correct focus style and is harder to deal with as it might
 * need additional props like spacing depending on where it's used.
 */

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css } from '@emotion/react';
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';

import { token } from '@atlaskit/tokens';

import { type StyledProps } from './Anchor.types';

const getColor = (props: StyledProps) =>
	props.appearance === 'subtle' ? token('color.text.subtle') : token('color.link');

const getHoverColor = (props: StyledProps) =>
	props.appearance === 'subtle' ? token('color.text.subtle') : token('color.link');

const getActiveColor = (props: StyledProps) =>
	props.appearance === 'subtle' ? token('color.text') : token('color.link.pressed');

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression -- needs manual remediation
export const AnchorCss = (props: StyledProps) => css`
	color: ${getColor(props)};

	&&:hover {
		color: ${getHoverColor(props)};
		text-decoration: underline;
	}

	&&:focus {
		outline: 2px solid ${token('color.border.focused')};
		outline-offset: 2px;
	}

	&&:active {
		color: ${getActiveColor(props)};
		outline: none;
		text-decoration: none;
	}
`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const NormalStyledAnchor = styled.a(AnchorCss);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
export const StyledLink = styled(Link)(AnchorCss);
